export default {
  methods: {
    copy(data) {
      navigator.permissions.query({ name: 'clipboard-write' }).then(result => {
        if (result.state === 'granted') {
          var blob = new Blob([data], {type: 'text/plain'});
          // eslint-disable-next-line no-undef
          var item = new ClipboardItem({'text/plain': blob});
          navigator.clipboard.write([item]).then( () => {
            this.$notify({text: 'Copied', type: 'success'})
          })
        } else {
          console.log("clipboard-permissoin not granted: " + result);
        }
      });
    }
  }
}